import React from 'react';
import classnames from 'classnames';
import { HouseOutlineIcon } from 'assets/icons';

import { useSelector } from 'store';
import { useAppNavigate } from 'hooks';

import styles from 'theme/components/controls/wise/WiseBreadcrumbsControl/WiseBreadcrumbsControl.module.scss';

const WiseBreadcrumbsControl = ({
  isLoading = false
}: {
  isLoading?: boolean;
}) => {
  const navigate = useAppNavigate();
  const { breadcrumbs } = useSelector((state) => state.ui);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        'StylePath-Components-Controls-wise-WiseBreadcrumbsControl'
      )}
      itemScope
      itemType="http://schema.org/BreadcrumbList">
      <div className={styles.breadcrumbs}>
        <HouseOutlineIcon onClick={() => navigate('/')} className={styles.home} />

        {!isLoading &&
          breadcrumbs.map(({ name, path }) => (
            <span
              key={`${path}-${name}`}
              className={styles.breadcrumb}
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem">
              <meta itemProp="item" content={path} />
              <span className={styles.arrow}>›</span>
              <span
                onClick={() => path && navigate(path)}
                className={classnames(styles.name, { [styles.disabled]: !path })}
                itemProp="name">
                {name}
              </span>
            </span>
          ))}
      </div>
    </div>
  );
};

export default WiseBreadcrumbsControl;
